import * as React from 'react'
import { Text } from '@amzn/dvui/dist/Text'
import * as st from './secondaryOfferMessage.module.scss'

export interface ISecondaryOfferMessageProps {
  messages?: string[]
}

export const SecondaryOfferMessage = ({ messages }: ISecondaryOfferMessageProps) => {
  if (!messages || !messages.length) {
    return null
  }

  return (
    <div className={st.wrapper}>
      {messages.map((message, idx) => (
        <div key={`secondary-offer-${idx}`} className={st.message}>
          <Text string={message} />
        </div>
      ))}
    </div>
  )
}
